import React, { useState, useEffect } from 'react';
import { Modal, Input, Typography, Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function ModalEnviarEmail({
  visible,
  onClose,
  emails,
  setEmails,
  onEnviar,
  loading = false,
  proveedorEmail = ''
}) {
  const [listaEmails, setListaEmails] = useState(['']);

  useEffect(() => {
    if (visible) {
      if (emails && emails.trim()) {
        setListaEmails(emails.split(',').map(e => e.trim()));
      } else if (proveedorEmail && proveedorEmail.trim()) {
        setListaEmails([proveedorEmail.trim()]);
      } else {
        setListaEmails(['']);
      }
    }
  }, [visible, emails, proveedorEmail]);

  const handleAgregarEmail = () => {
    setListaEmails([...listaEmails, '']);
  };

  const handleEliminarEmail = (index) => {
    const nuevaLista = listaEmails.filter((_, i) => i !== index);
    setListaEmails(nuevaLista.length > 0 ? nuevaLista : ['']);
  };

  const handleCambiarEmail = (index, valor) => {
    const nuevaLista = [...listaEmails];
    nuevaLista[index] = valor;
    setListaEmails(nuevaLista);
  };

  const handleEnviar = () => {
    const emailsValidos = listaEmails
      .map(e => e.trim())
      .filter(e => e.length > 0);

    if (emailsValidos.length === 0) {
      return;
    }

    const emailsString = emailsValidos.join(',');
    onEnviar(emailsString);
  };

  const handleCancelar = () => {
    setListaEmails(['']);
    onClose();
  };

  return (
    <Modal
      title="Solicitar Factura por Email"
      open={visible}
      onCancel={handleCancelar}
      onOk={handleEnviar}
      okText="Enviar"
      cancelText="Cancelar"
      confirmLoading={loading}
      className="pagos-v2-modal"
    >
      <div style={{ marginBottom: 16 }}>
        <Text type="secondary">
          Ingresa los correos electrónicos del proveedor
        </Text>
      </div>

      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        {listaEmails.map((email, index) => (
          <div key={index} style={{ display: 'flex', gap: '8px', width: '100%' }}>
            <Input
              placeholder="ejemplo@correo.com"
              value={email}
              onChange={(e) => handleCambiarEmail(index, e.target.value)}
              style={{ flex: 1 }}
              type="email"
              size="large"
            />
            {listaEmails.length > 1 && (
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleEliminarEmail(index)}
                size="large"
              />
            )}
          </div>
        ))}

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={handleAgregarEmail}
          >
            Agregar otro correo
          </Button>
        </div>
      </Space>
    </Modal>
  );
}